import { productAccessorStockStatusIsFreebie } from '../../model/productAccessor/productAccessorStockStatusIsFreebie'
import { productAccessorStockStatusIsOutOfSale } from '../../model/productAccessor/productAccessorStockStatusIsOutOfSale'
import { PRODUCT_TEMPLATES } from '../../model/productTemplates'
import { useProductPageContext } from '../productPageContext'

export const useHideAddToCart = (): boolean => {
  const { followUpProduct, product, productTemplate } = useProductPageContext()

  const freebieOrOutOfSale =
    productAccessorStockStatusIsOutOfSale(product) ||
    productAccessorStockStatusIsFreebie(product)

  return (
    productTemplate !== PRODUCT_TEMPLATES.RX &&
    freebieOrOutOfSale &&
    !followUpProduct?.canonical_url
  )
}
